import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import FeedingBargesList from './FeedingBargesList';
import { icon } from 'leaflet';

//redux

const FeedingBarges = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Operaciones', icon: 'icon-wrench' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Artefacto Naval' links={breadcrumbLinks} icon={'icon-map-pin-house'} />
					<FeedingBargesList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default FeedingBarges;
